import { render, staticRenderFns } from "./GroupsOnly.vue?vue&type=template&id=986252dc&"
import script from "./GroupsOnly.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupsOnly.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_qqg2mlm7tcp4cjng2lo6klgciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports